module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab_container"
  }, [_c('div', {
    staticClass: "tab_content",
    staticStyle: {
      "height": "306px"
    },
    attrs: {
      "id": "tab1"
    }
  }, [_c('div', {
    staticClass: "tab_incon"
  }, [_vm._l((_vm.topNotice), function(notice, index) {
    return (index < 4) ? _c('div', {
      key: notice.id
    }, [_c('div', {
      staticClass: "fix"
    }), _vm._v(" "), _c('div', {
      staticClass: "list"
    }, [_c('a', {
      attrs: {
        "target": _vm.target(notice),
        "href": _vm.href(notice)
      },
      on: {
        "click": function($event) {
          _vm.pushToNewsSub(notice, $event)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "border-bottom": "#ccc 1px dotted",
        "padding": "5px 0",
        "margin-right": "6px"
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_vm._v(_vm._s(notice.createdAt.split(' ')[0]))]), _vm._v(" "), _c('div', {
      staticClass: "right",
      staticStyle: {
        "height": "20px",
        "line-height": "20px",
        "overflow": "hidden"
      }
    }, [_c('span', {
      staticClass: "nhott"
    }, [_vm._v("HOT")]), _vm._v(_vm._s(notice.title))]), _c('img', {
      attrs: {
        "src": "/../static/images/stickyPin.png"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "fix"
    })])])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.normalNotices), function(notice, index) {
    return _c('div', {
      key: notice.id
    }, [_c('div', {
      staticClass: "fix"
    }), _vm._v(" "), _c('div', {
      staticClass: "list"
    }, [_c('a', {
      attrs: {
        "target": _vm.target(notice),
        "href": _vm.href(notice)
      },
      on: {
        "click": function($event) {
          _vm.pushToNewsSub(notice, $event)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "border-bottom": "#ccc 1px dotted",
        "padding": "5px 0",
        "margin-right": "6px"
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_vm._v(_vm._s(notice.createdAt.split(' ')[0]))]), _vm._v(" "), _c('div', {
      staticClass: "right",
      staticStyle: {
        "height": "20px",
        "line-height": "20px",
        "overflow": "hidden"
      }
    }, [_vm._v(_vm._s(notice.title))]), _vm._v(" "), _c('div', {
      staticClass: "fix"
    })])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "fright mt10"
  }, [_c('router-link', {
    staticClass: "more_btn",
    attrs: {
      "to": _vm.newsMoreTo
    }
  }, [_vm._v("more")])], 1), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-249fac07","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HomeNotice.vue
// module id = 1206
// module chunks = 4